///<reference path="../../employee/sections/employee.serviceCommissions.section.ts"/>
module Meevo.Plugins.Student {
    "use strict";

    /**
    * Service Commissions Section of Employee
    */
    export class ServiceCommissionsSection extends Meevo.Plugins.Employee.ServiceCommissionsSection {
        public get auditNounForSave() {
            return Model.NounEnum.StudentServiceCommissionOverride;
        }
    }
}